module.exports = __webpack_public_path__ + "img/right-shadow.40045f37.png";